import { RoiChange } from '@analysis/domain';
import { type RoiChangesRepository } from '../../ports';

export interface RestoreUnsavedChangesPayload {
  sampleId: string;
  analystId: string;
}

export class RestoreUnsavedChangesUseCase {
  constructor(private readonly roiChanges: RoiChangesRepository) {}

  public async execute(input: Readonly<RestoreUnsavedChangesPayload>): Promise<Map<string, RoiChange>> {
    const { sampleId, analystId } = input;

    const changes = await this.roiChanges.getForSampleAndAnalyst(sampleId, analystId);

    const changeMap: Map<string, RoiChange> = new Map();

    for (const change of changes) {
      changeMap.set(change.id, change);
    }

    return changeMap;
  }
}
